import { useTranslation } from 'react-i18next';
const UnauthorizedPage = () => {
const {t} = useTranslation();

  return (
    <div> 
      <h1>{t('unauthorizedpage.caption.unauthorizedHead')}</h1>
      <p>{t('unauthorizedpage.caption.unauthorized')}</p>
    </div>
  );
};

export default UnauthorizedPage;
